import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { hasValue } from '../../../../utils/helpers/value'
import { templatesClient } from '../../../../utils/apollo/api'
import { useModalData, useModalsActions } from '../../../../components/modals/ModalsContext'
import { useNavigationWithModalCloser } from '../../../../utils/contexts/NavigationContext'

const MUTATION = gql`
  mutation UpsertTemplate($input: TemplateInput) {
    upsertTemplate(input: $input) {
      id
      type
    }
  }
`

const validate = (form, setErrors) => {
  const isDocx = form.type === 'docx'
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }),
    ...appendIf(!form.type, { path: ['type'], message: 'Campo obrigatório' }),
    ...appendIf(isDocx && !hasValue(form.document), {
      path: ['document'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(isDocx && document?.lenght > 1, {
      path: ['document'],
      message: 'Limite excedido(somente um documento é permitido)'
    })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveTemplate = () => {
  const { onGoBack } = useModalsActions()
  const nvaigate = useNavigationWithModalCloser()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Template'], client: templatesClient })
  const { entity } = useModalData()

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      const input = cleanRequest(form, entity)
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          const record = resp.data?.upsertTemplate || {}
          if (record.type === 'dynamic_pdf') {
            nvaigate(`/templates/${record.id}/content`)
          } else {
            onGoBack()
          }
        }
      })
    }
  }

  return [handleRequest, state]
}
